import {
  AdvertiserPerformanceStatsPartsFragment,
  AdvertiserPerformanceStatsQuery,
  CostDetailsDimensions,
  CostDetailsFilter,
  PublisherPerformanceStatsPartsFragment,
  PublisherPerformanceStatsQuery,
  ResellerAdvertiserPerformanceStatsQuery,
} from '../../../__generated__/graphql'

type PublisherAdvertiserReseller =
  PublisherPerformanceStatsQuery['publisher']['performanceStats']['advertiserResellers']

type AdvertiserPublisherReseller =
  AdvertiserPerformanceStatsQuery['advertiser']['performanceStats']['publisherResellers'][number]

type AdvertiserWebsiteFromQuery = AdvertiserPublisherReseller['publishers'][number]['websites'][number]

const websiteWithPublisherName = (website: AdvertiserWebsiteFromQuery, publisherName: string): FlatAdvertiserWebsite =>
  Object.assign({}, website, { additionalInfo: publisherName })

export type FlatPublisherCampaign = {
  name: string
  slug?: string | null
  stats: PublisherPerformanceStatsPartsFragment
}

export type FlatAdvertiserWebsite = AdvertiserWebsiteFromQuery & { additionalInfo: string }

type ResellerAdvertiserWithPerformance =
  ResellerAdvertiserPerformanceStatsQuery['reseller']['advertiserPerformanceStats']['advertisers'][number]

export type FlatAdvertiserCampaign = {
  name: string
  id: string
  slug: string
  stats: AdvertiserPerformanceStatsPartsFragment
}

export const flatAdvertisersCampaigns = (
  advertisers: ResellerAdvertiserWithPerformance[] | undefined
): FlatAdvertiserCampaign[] =>
  advertisers?.flatMap((advertiser) =>
    advertiser.campaigns.map((campaign) => ({
      name: campaign.name,
      id: campaign.id,
      slug: advertiser.slug,
      stats: campaign.stats,
    }))
  ) ?? []

export const flatResellersCampaigns = (resellers: PublisherAdvertiserReseller): FlatPublisherCampaign[] =>
  resellers?.flatMap((reseller) => {
    if (reseller.advertisers.length === 0)
      return {
        name: reseller.name,
        slug: undefined,
        stats: reseller.stats,
      }

    return reseller.advertisers.flatMap((advertiser) =>
      advertiser.campaigns.map((campaign) => ({
        name: campaign.name,
        slug: advertiser.slug,
        stats: campaign.stats,
      }))
    )
  }) || []

export const flatResellersWebsites = (resellers: AdvertiserPublisherReseller[]): FlatAdvertiserWebsite[] =>
  resellers?.flatMap((reseller) =>
    reseller.publishers.flatMap((publisher) =>
      publisher.websites.map((website) => websiteWithPublisherName(website, publisher.name))
    )
  ) || []

export const buildDimensionFilterVariables = (
  dimension: CostDetailsDimensions,
  values: Record<CostDetailsDimensions, string[]>
): CostDetailsFilter[] => {
  if (values === undefined || values[dimension] === undefined) return []
  return [{ dimension, values: values[dimension] }]
}
